import { memo } from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

type Props = {
  loading: boolean;
  light?: boolean;
};

export const Loader: React.FC<Props> = memo(function Loader({ loading, light = false }) {
  if (!loading) {
    return null;
  }

  return (
    <div className={classNames(styles.container, { [styles.container_light]: light })}>
      <div />
      <div />
      <div />
    </div>
  );
});
